/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios from "../../api";
import { Box, Button, Typography, Stack, Grid, Modal } from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { usePopUpContext } from "../../Context/PopupMessage";
const InvoiceDetails = (props) => {
  
  const { setPopupMessage, setLoading } = usePopUpContext();
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [assetRows, setAssetRows] = useState([]);
  const [assetColumns, setAssetColumns] = useState([
    {
      field: "aplDesc",
      headerName: "Check No",
      sortable: false,
      width: 250,
    },
    {
      field: "trsDts",
      headerName: "Date",
      sortable: false,
      width: 250,
    },
    {
      field: "amtStr1",
      headerName: "Amount",
      type: 'number',
      sortable: false,
      width: 250,
    },
  ]);

  const apiRef = useGridApiRef();

  useEffect(() => {
    setLoading(true)
    var postData = {
      prsMd: props.data?.prsMd,
      cusNo: Number(props.data?.cusNo?.keyStr),
      refDt: props.data?.refDt,
      brh: props.data?.brh,
      refPfx: props.data?.refPfx,
      refNo: Number(props.data?.refNo),
    };
    console.log(props);
    console.log(postData);

    axios
      .post("/invoiceDetail", postData)
      .then((res) => {
      
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
        setInvoiceDetails(res.data.output);
        setLoading(false)
        setAssetRows(res.data.output.fldTbl);
      })
      .catch((err) => {
        setLoading(false)
        console.log("AXIOS ERROR: ", err);
      });
  }, []);



  const exportOnClick = async (filename) => {

    let type ="original_invoice"
    let url = `/downloadfile?filepath=${filename}&&filename=${type}`

    axios({
        method: 'get',
        url: url,
        // responseType: 'blob',

    })
        .then((res, req) => {
          
             
                const url = window.URL.createObjectURL(new Blob([res.data]));
                // var filename = "";
                var fileName ="original_invoice"+ Date.now() + ".txt"

                const link = document.createElement('a');
                link.href = url;
                // link.target="_blank" 
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
      

        })
        .catch((error) => {
            setPopupMessage({ state: true, type: "error", message: error.response.data.message })
        })

}
const getFileName = async( refNo) => {

// setLoading(true)

let url = "/arcdocsvc";
let params ={
"prsMd":"R",
"busDocTyp": "INV",
"cusNo": Number(props.data?.cusNo?.keyStr),
"fldTbl":[
      {
          "brh":props.data?.brh, 
          "refPfx":props.data?.refPfx, 
          "refNo": refNo,
         
          "refDt":props.data?.refDt, 
      }
  ]
}

await axios
.post(url, params)
.then((res) => {
  var arrResponse = res.data.output.prtFileNm;
  if(res.data.output.rtnSts===2){
    setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
  }
  exportOnClick(arrResponse)
  console.log(arrResponse);
})
.catch((e) => {
  console.log(e);
  setLoading(false)
  setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
});
};
  return (
    <>
      <Modal
        open={props.open} onClose={props.onClose} className="ixMainLayoutDetail">
        <Stack
          direction="column"
          justifyContent="space-evenly"
          spacing={2} className="ixDetailLayout" sx={{ display: "flex", height: "100%" }} >
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}
            className="ixMainHeaderDetailLayout">

            <Button className="ixButtonHeader" styletype="icon" onClick={props.onClose}><ArrowBackIosNewIcon />
            </Button>

            <Stack className="ixMainHeaderTitle">
              Invoice Details
            </Stack>
            <Button className="ixButtonHeader" styletype="icon">
              <InfoOutlinedIcon />
            </Button>
          </Stack>
          <Stack className="ixSmallDetailContainer" direction="column"  >
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <Typography className="ixBoldLabelBig"> Invoice </Typography>
              <Button onClick={()=>{getFileName(props.data?.refNo)}}>View Original Invoice</Button>
            </Stack>
            <Grid container spacing={1} sx={{ width: "80%" }}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end">Invoice No:</Grid>
              <Grid item xs={2}>{invoiceDetails.invNoStr}</Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end">PO No:</Grid>
              <Grid item xs={2}>{invoiceDetails.extRef}</Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end">Date:</Grid>
              <Grid item xs={2}>{invoiceDetails.refDtStr}</Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end" >Amount:</Grid>
              <Grid item xs={2}>{invoiceDetails.amtStr}</Grid>

              <Grid item xs={3}></Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end">Release:</Grid>
              <Grid item xs={2}>{invoiceDetails.relNoStr}</Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end" >Due Date:</Grid>
              <Grid item xs={2}>{invoiceDetails.dueDts}</Grid>

              <Grid item className="ixFormTitleGrey" xs={1} textAlign="end" >Balance:</Grid>
              <Grid item xs={2}>{invoiceDetails.balStr}</Grid>
            </Grid>
          </Stack>

          <Box className="ixSmallDetailContainer" sx={{ height: "70%" }} >
            <DataGridPro 
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.aplDesc}
              rows={assetRows}
            />
          </Box>
        </Stack >
      </Modal >
    </>
  );
};

export default InvoiceDetails;
